<template>
  <div>
    <el-tag
      v-for="sea in tagList"
      :type="sea.key=='TypeView'?'danger':''"
      :key="sea.key + sea.title"
    >{{sea.title+':'+sea.value}}</el-tag>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      searchCondition: state => state.task.searchCondition
    })
  },
  props:{
    tagList:{
      type:Array,
      default:()=>{
        return [];
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>